import apiClient from './apiClient';

export interface ReadFirstListParams {
  projectId?: string;
  status?: string;
}

class ReadFirstRegisterService {
  async list(endpoint: string, params: ReadFirstListParams = {}): Promise<any[]> {
    const response = await apiClient.get(endpoint, { params });
    const payload = response.data;
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.items)) return payload.items;
    if (Array.isArray(payload?.rows)) return payload.rows;
    if (Array.isArray(payload?.data)) return payload.data;
    return [];
  }

  async get(endpoint: string, id: string): Promise<any> {
    const response = await apiClient.get(`${endpoint}/${id}`);
    return response.data;
  }

  async create(endpoint: string, payload: Record<string, any>): Promise<any> {
    const response = await apiClient.post(endpoint, payload);
    return response.data?.data ?? response.data;
  }

  async patch(endpoint: string, id: string, path: string, payload: Record<string, any>): Promise<any> {
    const response = await apiClient.patch(`${endpoint}/${id}${path}`, payload);
    return response.data?.data ?? response.data;
  }
}

export default new ReadFirstRegisterService();
